import { FC } from 'react';

type Props = {
  className?: string;
};

export const PlusSubscriptionUpgradeNowModalClose: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.75 19.75L2.25 2.25M19.75 2.25L2.25 19.75"
      stroke="#333333"
      strokeWidth="2.5963"
      strokeLinecap="round"
    />
  </svg>
);
